import { useQuery } from "@tanstack/react-query";
import { useShellStore } from "../../store";
import { billingApi } from "./billingApi";

export const BILLING_STATUS_QUERY_KEY = ["billing-status"] as const;

/** How often the shell re-reads where the organization stands. */
export const BILLING_STATUS_POLL_MS = 15 * 60 * 1000;

/**
 * Where the signed-in user's organization stands with its bills.
 *
 * Read on load and every 15 minutes (the lifecycle moves stages hourly, so
 * that is plenty for a banner). The billing-only screen polls faster while it
 * waits for a payment to be confirmed — pass `refetchInterval`.
 */
export function useBillingStatus(options: { refetchInterval?: number | false; enabled?: boolean } = {}) {
  const isAuthenticated = useShellStore((s) => s.isAuthenticated);
  return useQuery({
    queryKey: BILLING_STATUS_QUERY_KEY,
    queryFn: () => billingApi.status(),
    enabled: isAuthenticated && (options.enabled ?? true),
    refetchInterval: options.refetchInterval ?? BILLING_STATUS_POLL_MS,
    staleTime: 60 * 1000,
    retry: 1,
  });
}
